import React from 'react';
import { TextInput, useNotify, email, useRedirect } from 'react-admin';
import { StyledPage } from '../../../components/StyledPage';
import { CreateBody } from '../../../components/CreateBody';
import CustomToolbar from '../../../components/CustomToolbar';
import StyledSimpleForm from '../../../components/StyledSimpleForm';
import { CreateHeader } from './components';

const TeammatesCreate = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();

  const onSuccess = ({data}) => {
    notify(`${data.email} has been added to your team. We've sent an email to your new teammate with instructions on how to log in.`)
    redirect('/teammates');
  }

  return <StyledPage>
    <CreateHeader/>
    <CreateBody {...props} onSuccess={onSuccess}>
      <StyledSimpleForm toolbar={<CustomToolbar cancelUrl='/teammates' customSaveBtnLabel='Add'/>} {...props} >
        <TextInput
          source="email"
          label="Email"
          type="email"
          data-testid='create-teammate-email-input'
          helperText={false}
          validate={email("Please enter a valid email address")}
        />
      </StyledSimpleForm>
    </CreateBody>
  </StyledPage>;
};

export default TeammatesCreate;
